// StringConstants.js
/**
 * @module StringConstants
 *
 */

const ValidationMessageConstants = {
  referenceErrorMessage: 'Enter a reference for this payment then try again.',
  sortCodeErrorMessage: 'Enter their six-digit sort code then try again.',
  accountNumberErrorMessage:
    'Enter their eight digit account number then try again.',
  paymentReferenceErrorMessage:
    'Enter a reference for this payment then try again.',
  amountErrorMessage: 'Enter the amount you want to pay then try again.',
  youthAccountAmountExceededMessage:
    'The payment limit for this account is £200. Please amend and try again.',
  nextDateErrorMessage:
    'Choose the date you want the next payment to come out. This should be entered as DD/MM/YYYY.',
  futureDateErrorMessage:
    'Choose the date you want the next payment to come out. This should be entered as DD/MM/YYYY.',
  endDateErrorMessage:
    'The date you’ve chosen to stop this payment doesn’t match up with your payment frequency or the date you’ve chosen to start it. Double check your details are right then try again.',
  noOfTimesErrorMessage:
    'Enter the number of payments you want to make before this repeating payment stops.',
  noOfTimesEdgeCaseMessage:
    'Oops, that’s too many payments. Enter 300 or less then try again.',

  // Move Money Validation Constants
  amountFieldRequiredErrorMessage:
    'Please enter the amount of money you want to move.',
  amountEdgeCaseErrorMessage:
    'Sorry, you’re not allowed to move that much online in one transaction. You can see how much you can move in the FAQs.',
  whenErrorMessage:
    'Choose the date you want to make this payment. This should be entered as DD/MM/YYYY.',
  startDateErrorMessage:
    'Choose the date you want to make repeating payment. This should be entered as DD/MM/YYYY.',
  howOftenErrorMessage: 'Please select one of the options.',
};

export default ValidationMessageConstants;
